import { Cubby } from "../stores/Cubby";
import { validate, Network } from "bitcoin-address-validation";

export const validateBitcoinAddress = (
  cubby: Cubby,
  bitcoinAddress: string
) => {
  let isValid = false;
  if (cubby.cubbyNetwork === "mainnet") {
    isValid = validate(bitcoinAddress, Network.mainnet);
  }

  if (cubby.cubbyNetwork === "testnet") {
    isValid = validate(bitcoinAddress, Network.testnet);
  }
  return isValid;
};

export const maybeGetFeeEstimate = (
  newSatoshis: number | null,
  newBitcoinAddress: string,
  newSatoshisError: string,
  newBitcoinAddressError: string,
  sendAll: boolean,
  cubby: Cubby
) => {
  if (sendAll) {
    cubby.resetLastOnchainFeeEstimates();
    return;
  }

  console.log(
    "bitcoinAddressError",
    newBitcoinAddressError,
    "satoshisError",
    newSatoshisError,
    "bitcoinAddress",
    newBitcoinAddress,
    "satoshis",
    newSatoshis,
    "sendAll",
    sendAll
  );

  if (
    newBitcoinAddressError === "" &&
    newSatoshisError === "" &&
    newBitcoinAddress !== "" &&
    newSatoshis > 0
  ) {
    console.log(
      "Will get fee estimate now for",
      newBitcoinAddress,
      newSatoshis
    );
    cubby.getFeeEstimate(newSatoshis, newBitcoinAddress);
    // You can add the logic to get fee estimate here.
  }
};
